"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TermsContentResponseMapper = void 0;
var TermsContentResponseMapper = /** @class */ (function () {
    function TermsContentResponseMapper(data) {
        this.localData = data;
    }
    TermsContentResponseMapper.prototype.getDataObject = function () {
        return this.localData;
    };
    return TermsContentResponseMapper;
}());
exports.TermsContentResponseMapper = TermsContentResponseMapper;
//# sourceMappingURL=TermsContentResponseMapper.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/checkout-ui/models/mappers/TermsContentResponseMapper.js
// module id = 2074
// module chunks = 8